import { DatePipe } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { AngularFireAnalytics } from "@angular/fire/compat/analytics";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { MatIcon } from "@angular/material/icon";
import { Plugins } from "@capacitor/core";
import { AuthService } from "@core/auth.service";
import { IonicModule } from "@ionic/angular";
import { TranslatePipe } from "@ngx-translate/core";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";

const { Browser } = Plugins;

@Component({
    selector: "app-list-of-checks",
    templateUrl: "./list-of-checks.component.html",
    styleUrls: ["./list-of-checks.component.scss"],
    standalone: true,
    imports: [
        IonicModule,
        MatIcon,
        DatePipe,
        TranslatePipe,
    ],
})
export class ListOfChecksComponent implements OnInit {
  userId: string;
  constructor(
    private matBottomSheet: MatBottomSheetRef<ListOfChecksComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private analytics: AngularFireAnalytics,
    private GTMSegment: GTMSegmentService,
    private authService: AuthService
  ) {
    this.GTMSegment.GTMPopupInitialization("ListOfChecks");
  }

  async ngOnInit() {
    await this.authService
      ?.getUid("ListOfChecksComponent")
      ?.then((uid) => {
        this.userId = uid;
        this.analytics.logEvent("syndicate_list_of_checks_event", { userId: this.userId });
      })
      .catch((error: any) => {
        return error;
      });
  }

  openPrizePage(claimEventId) {
    this.matBottomSheet.dismiss({ claimEventId });
  }

  backToSyndicate() {
    this.matBottomSheet.dismiss();
  }

  helpSupportWebview() {
    this.openInAppBrowser("https://help.lotto-social.com/hc/en-us/?app=1");
  }

  async openInAppBrowser(urlData: string) {
    if (Browser) {
      await Browser.open({ url: urlData });
      window.open(urlData);
    }
  }
}
